var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90589 10.8333C6.90589 10.941 6.86309 11.0444 6.7869 11.1206C6.71072 11.1968 6.60739 11.2396 6.49964 11.2396C6.3919 11.2396 6.28857 11.1968 6.21238 11.1206C6.13619 11.0444 6.09339 10.941 6.09339 10.8333V5.82289H3.24964C3.16935 5.82281 3.09087 5.79895 3.02413 5.75431C2.95739 5.70966 2.90537 5.64624 2.87465 5.57205C2.84394 5.49786 2.83589 5.41624 2.85154 5.33748C2.86718 5.25872 2.90582 5.18637 2.96256 5.12955L6.21256 1.87955C6.28873 1.80347 6.39199 1.76074 6.49964 1.76074C6.6073 1.76074 6.71055 1.80347 6.78673 1.87955L10.0367 5.12955C10.0935 5.18637 10.1321 5.25872 10.1477 5.33748C10.1634 5.41624 10.1554 5.49786 10.1246 5.57205C10.0939 5.64624 10.0419 5.70966 9.97516 5.75431C9.90841 5.79895 9.82994 5.82281 9.74964 5.82289H6.90589V10.8333Z",
    fill: "#6C757D",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.95e64c09b87f5025aa63c60cac662e63.svg";
export { ForwardRef as ReactComponent };